// extracted by mini-css-extract-plugin
export var page = "pageMostCollections-module--page--In11p";
export var framesContainer = "pageMostCollections-module--framesContainer--ZAuq3";
export var frames = "pageMostCollections-module--frames--Bc2VA";
export var frame = "pageMostCollections-module--frame--8qV69";
export var frame1 = "pageMostCollections-module--frame1--mMvH7";
export var frame2 = "pageMostCollections-module--frame2--t7wzL";
export var frame3 = "pageMostCollections-module--frame3--Dssud";
export var text = "pageMostCollections-module--text--+PrGU";